import { Checkbox, CheckboxChangeEvent, CheckboxProps } from '@progress/kendo-react-inputs';

type PropsType = Omit<CheckboxProps, 'onChange'> & {
    onChange?: (event: Omit<CheckboxChangeEvent, 'value'> & { value: boolean | null }) => void;
};

export function CheckboxThreeState(props: PropsType) {
    return (
        <Checkbox
            {...props}
            onChange={(e) => {
                if (props.checked == null) {
                    props.onChange?.({ ...e, value: true });
                } else if (props.checked === true) {
                    props.onChange?.({ ...e, value: false });
                } else {
                    props.onChange?.({ ...e, value: null });
                }
            }}
        />
    );
}
